import { render } from "./QbTableItem.vue?vue&type=template&id=782d97c5&scoped=true"
import script from "./QbTableItem.vue?vue&type=script&lang=js"
export * from "./QbTableItem.vue?vue&type=script&lang=js"

import "./QbTableItem.vue?vue&type=style&index=0&id=782d97c5&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-782d97c5"]])

export default __exports__